import React from 'react';
import OnePlanetEventImg from '../../assets/imgs/CoinbaseHome/event_oneplanet.png';
import TradeBattleCardsTreasuryImg from '../../assets/imgs/CoinbaseHome/event_trade_cards_and_treasury.png';
import styles from './EventsSection.module.scss';

const Events = [
    {
        title: "Trade TOWER NFTs on OnePlanet",
        description: "You can now trade TOWER NFTs with polygon TOWER Token on OnePlanet NFT Marketplace!",
        type: "Event",
        detailsLink: "https://community.oneplanetnft.io/tower_event",
        image: OnePlanetEventImg,
    },
    {
        title: "Trade Battle Cards & Treasury on and gain exclusive Achievement Badges",
        description: "Transaction on OnePlanet will receive an Achievement Badge, also enjoy 50% off on transaction fee!",
        type: "Event",
        detailsLink: "https://medium.com/tower-token/introducing-the-oneplanet-x-tower-token-mega-event-get-exclusive-trading-offers-and-achievement-1edde3be1d07",
        image: TradeBattleCardsTreasuryImg,
    },
];

const EventsSection = () => {
    return (
        <div className={styles.events_list}>
            {/* <div className={`${styles.navigation_btn} ${styles.left}`}></div> */}
            <div className={styles.events}>
                {Events.map((event, index) => (
                    <div className={styles.event} key={index}>
                        <div className={styles.event_image}>
                            <img src={event.image} alt={event.title} /> 
                        </div>
                        <div className={styles.event_details}>
                            <div className={styles.event_type}>{event.type}</div>
                            <div className={styles.event_title}>{event.title}</div>
                            <div className={styles.event_description}>{event.description}</div>
                            <div className={styles.more_detail}>
                                <a href={event.detailsLink} target="_blank" rel="noopener noreferrer">
                                    {'More Details >'}
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {/* <div className={`${styles.navigation_btn} ${styles.right}`}></div> */}
        </div>
    )
}

export { EventsSection }
